export const nycFips = '36999';
export const nycCounties = [
  { STATEFP: '36', NAME: 'Kings', fips: '36047'},
  { STATEFP: '36', NAME: 'Queens', fips: '36081'},
  { STATEFP: '36', NAME: 'New York', fips: '36061'},
  { STATEFP: '36', NAME: 'Bronx', fips: '36005'},
  { STATEFP: '36', NAME: 'Richmond', fips: '36085'},
]

export const kansasCityFips = '29999';